import { AnchorHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';

export const UnstyledAnchor = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement>
>((props, ref) => (
  <StyledAnchor {...props} ref={ref}>
    {props?.children ?? null}
  </StyledAnchor>
));
UnstyledAnchor.displayName = 'UnstyledAnchor';

const StyledAnchor = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  border: none;
  padding: 0;
  font: inherit;

  &:hover {
    color: inherit;
  }
`;
